import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxLoadingModule } from 'ngx-loading';
import { SharedModule } from '../../shared/shared.module';
import { AlertConfigRoutingModule } from './alert-config.routing';
import { AlertConfigComponent } from './pages/alert-config/alert-config.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    AlertConfigRoutingModule,
    SharedModule,
    NgxLoadingModule
  ],
  declarations: [AlertConfigComponent]
})
export class AlertConfigModule {}
